import { env } from "../env";
import pako from "pako";

const GetOrg = async (token, callback) => {
  try {
    const response = await fetch(env.APIPath.org, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    if (data.status === "ok") {
      if (callback) {
        callback(data.org);
      }
      //console.log(JSON.stringify(data.org))
    } else {
      if (callback) {
        callback(data);
      }
      console.log("error", data);
    }
  } catch (error) {
    console.log(error.message);
  }
};

const GetAlertSubscriptions = async (token) => {
  try {
    const response = await fetch(env.APIPath.getAlerts, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    if (data.status === "ok") {
      return data;
    } else {
      console.log("error", data);
    }
  } catch (error) {
    console.log(error.message);
  }
};

const GetOrgUseQuery = async (token, queryKey) => {
  try {
    const response = await fetch(env.APIPath.org, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    if (data.status === "ok") {
      console.log("Data fetched:", data);
      return data; // Return org data
      //console.log(JSON.stringify(data.org))
    } else {
      console.log("error", data);
    }
  } catch (error) {
    console.log(error.message);
  }
};
// This is a POST method that takes the projection as input
const PostOrgV2 = async (token, body) => {
  try {
    // console.log(org);
    const response = await fetch(env.APIPath.getOrg, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    // console.log('Post Org', JSON.stringify(data));
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const PostOrg = async (token, org) => {
  try {
    // console.log(org);
    const response = await fetch(env.APIPath.org, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        org: org,
      }),
    });
    const data = await response.json();
    // console.log('Post Org', JSON.stringify(data));
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const PostOrgTechsupport = async (token, org) => {
  try {
    // console.log(org);
    const response = await fetch(
      env.APIPath.orgtechsupport,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          org: org,
        }),
      }
    );
    const data = await response.json();
    // console.log('Post Org', JSON.stringify(data));
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const GetDGOrgConfig = async (token, dgname) => {
  // console.log("GetDGOrgConfig dgname", dgname)
  try {
    console.log(dgname);
    const response = await fetch(
      env.APIPath.getdgorgconfig,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          dgname: dgname,
        }),
      }
    );
    const data = await response.json();
    // console.log('GetDGOrgConfig get DG Org config', dgname, data);
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const GetDGOrgConfigV2 = async (
  token,
  siteName,
  dgname
) => {
  try {
    console.log(dgname);
    const response = await fetch(
      env.APIPath.getdgorgconfigV2,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          siteName: siteName,
          dgname: dgname,
        }),
      }
    );
    const data = await response.json();
    // console.log('GetDGOrgConfigV2 get DG Org config', dgname, data);
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const GetSiteOrgConfig = async (token, siteName) => {
  try {
    const response = await fetch(
      env.APIPath.getsiteorgconfig,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          siteName: siteName,
        }),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const PostDGOrgConfig = async (token, dgname, config) => {
  try {
    // console.log(dgname);
    const response = await fetch(
      env.APIPath.postdgorgconfig,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          dgname: dgname,
          config: config,
        }),
      }
    );
    const data = await response.json();
    // console.log(data);
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const PostDGOrgConfigV2 = async (token, body) => {
  try {
    const response = await fetch(
      env.APIPath.postdgorgconfigV2,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      }
    );
    const data = await response.json();
    // console.log(data);
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const PostSiteOrgConfig = async (token, body) => {
  try {
    const response = await fetch(
      env.APIPath.postsiteorgconfig,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const PostMultiDGOrgConfig = async (
  token,
  dglist,
  config
) => {
  try {
    // console.log(dglist);
    const response = await fetch(
      env.APIPath.postmultidgorgconfig,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          dglist: dglist,
          config: config,
        }),
      }
    );
    const data = await response.json();
    // console.log(data);
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const PostMultiDGOrgConfigV2 = async (
  token,
  siteName,
  dglist,
  config
) => {
  try {
    // console.log(dglist);
    const response = await fetch(
      env.APIPath.postmultidgorgconfigV2,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          siteName: siteName,
          dglist: dglist,
          config: config,
        }),
      }
    );
    const data = await response.json();
    // console.log(data);
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const PostMultiSiteOrgConfig = async (
  token,
  sitelist,
  config
) => {
  try {
    const response = await fetch(
      env.APIPath.postmultisiteorgconfig,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          sitelist: sitelist,
          config: config,
        }),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const GetUser = async (token, callback) => {
  try {
    const response = await fetch(env.APIPath.user, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    if (data.status === "ok") {
      if (callback) {
        callback(data.user);
      }
    } else {
      if (callback) {
        callback(data);
      }
    }
  } catch (error) {
    console.log(error.message);
  }
};

const GetUserUseQuery = async (token) => {
  try {
    const response = await fetch(env.APIPath.user, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      // You could optionally throw an error here
      throw new Error("Network response was not ok");
    }

    const data = await response.json();

    if (data.status === "ok") {
      return data; // Return user data
    } else {
      // You could throw an error here or return an empty object
      throw new Error(
        data.message || "Failed to fetch user info"
      );
    }
  } catch (error) {
    console.error("Error:", error.message);
    // Optionally, return some default value or throw the error
    throw error; // React Query will handle the error state
  }
};

const PostUserColorTheme = async ( authToken, body ) => {
  try {
    const response = await fetch(env.APIPath.theme, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (data.status === "ok") {
      // console.log(data);
      return data;
    } else {
      console.log(data);
      throw new Error(data.msg || "Failed to update user theme");
    }
  } catch (error) {
    console.error(
      "Error fetching user theme from API",
      error.message
    );
    throw error;
  }
};

const GetUserTechsupport = async (token, callback) => {
  try {
    const response = await fetch(
      env.APIPath.usertechsupport,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    if (data.status === "ok") {
      if (callback) {
        callback(data.user);
      }
    } else {
      if (callback) {
        callback(data);
      }
      // console.log(data);
    }
  } catch (error) {
    console.log(error.message);
  }
};

const GetUserTechsupportFilter = async (
  token,
  callback
) => {
  try {
    const response = await fetch(
      env.APIPath.usertechsupportfilter,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    if (data.status === "ok") {
      if (callback) {
        callback(data.user);
      }
    } else {
      if (callback) {
        callback(data);
      }
      // console.log(data);
    }
  } catch (error) {
    console.log(error.message);
  }
};


// const GetJobs = async (token, callback) => {
//   try {
//     const response = await fetch(env.APIPath.jobs, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     });
//     const data = await response.json();
//     if (data.status === "ok") {
//       if (callback) {
//         callback(data.job);
//       }
//     } else {
//       console.log(data);
//     }
//   } catch (error) {
//     console.log(error.message);
//   }
// };

const GetJobs = async ({ authToken, body }) => {
  try {
    const response = await fetch(env.APIPath.jobs, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(body),
    });
    if (!response.ok) {
      throw new Error(
        `HTTP error! Status: ${response.status}`
      );
    }
    const data = await response.json();

    return data;
  } catch (error) {
    console.error(
      "Error fetching data from API",
      error.message
    );
    throw error;
  }
};

const PostJobsBySerial = async ({ token, body }) => {
  try {
    const response = await fetch(env.APIPath.jobsBySerial, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const PostJobsBySerialCS = async ({ token, body }) => {
  try {
    const response = await fetch(env.APIPath.jobsBySerialCS, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const PostJobDetailsByID = async ({ token, body }) => {
  try {
    const response = await fetch(
      env.APIPath.jobdetailsbyid,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      }
    );
    const data = await response.json();
    //console.log("PostJobDetailsByID ", JSON.stringify(data));
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const PostJobDetailsByIDCount = async ({ token, body }) => {
  console.log("PostJobDetailsByIDCount body", body);
  console.log("PostJobDetailsByIDCount token", token);
  try {
    const response = await fetch(
      env.APIPath.jobDetailsByIdCount,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      }
    );
    const data = await response.json();
    //console.log("PostJobDetailsByID ", JSON.stringify(data));
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const PostJobInfoByID = async ({ token, body }) => {
  try {
    const response = await fetch(env.APIPath.jobinfobyid, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    //console.log("PostJobInfoByID ", JSON.stringify(data));
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const PostUser = async (token, user) => {
  try {
    // console.log('in PostUser', user);
    const response = await fetch(env.APIPath.user, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ user: user }),
    });
    const data = await response.json();
    if (data.status === "ok") {
      // console.log(data);
    } else {
      console.log(data);
    }
  } catch (error) {
    console.log(error.message);
  }
};

const PostUserSubscriptionPreference = async (
  token,
  user
) => {
  try {
    // console.log('in PostUser', user);
    const response = await fetch(
      env.APIPath.userWithSubscription,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ user: user }),
      }
    );
    const data = await response.json();
    if (data.status === "ok") {
      // console.log(data);
    } else {
      console.log(data);
    }
  } catch (error) {
    console.log(error.message);
  }
};
const PostUserWithAPIKeyNew = async (token, user) => {
  try {
    // console.log('in PostUser', user);
    const response = await fetch(env.APIPath.userAPINew, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ user: user }),
    });
    const data = await response.json();
    if (data.status === "ok") {
      return data;
    } else {
      throw new Error(data.message);
    }
  } catch (error) {
    console.log(error.message);
  }
};

const PostUserPreference = async (
  token,
  userPreference
) => {
  try {
    // console.log('in PostUserPreference', userPreference);
    const response = await fetch(env.APIPath.preference, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ user: userPreference }),
    });
    const data = await response.json();
    // console.log(data);
    return data;
  } catch (error) {
    console.log("catch error:", error.message);
  }
};

const PostAPIKey = async (token, user) => {
  try {
    const response = await fetch(env.APIPath.handleAPIKey, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ user: user }),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error.message);
    return null;
  }
};

const PostBTC = async (token, btcdata) => {
  try {
    const response = await fetch(env.APIPath.btc, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(btcdata),
    });
    const data = await response.json();
    if (data.status === "ok") {
      // console.log(data)
      return data;
    } else {
      console.log(data);
    }
  } catch (error) {
    console.log(error.message);
  }
};

const AddDG = async (token, dgdata) => {
  try {
    const response = await fetch(env.APIPath.addDG, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(dgdata),
    });
    const data = await response.json();
    if (data.status === "ok") {
      // console.log('add dg', data)
      return data;
    } else {
      console.log("add dg error", data);
      return data;
    }
  } catch (error) {
    console.log(" add dg catch error", error.message);
  }
};

const AddSite = async (token, sitedata) => {
  try {
    const response = await fetch(env.APIPath.addSite, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(sitedata),
    });
    const data = await response.json();
    if (data.status === "ok") {
      return data;
    } else {
      console.log("add site error", data);
      return data;
    }
  } catch (error) {
    console.log(" add site catch error", error.message);
  }
};

const DeleteDG = async (token, dgdata) => {
  try {
    const response = await fetch(env.APIPath.deleteDG, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(dgdata),
    });
    const data = await response.json();
    if (data.status === "ok") {
      // console.log('delete dg', data)
      return data;
    } else {
      console.log("delete dg error", data);
      return data;
    }
  } catch (error) {
    console.log("delete dg catch error", error.message);
  }
};

const DeleteSite = async (token, sitedata) => {
  try {
    const response = await fetch(env.APIPath.deleteSite, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(sitedata),
    });
    const data = await response.json();
    if (data.status === "ok") {
      return data;
    } else {
      console.log("delete site error", data);
      return data;
    }
  } catch (error) {
    console.log("delete site catch error", error.message);
  }
};

const AddDGMember = async (token, dgdata) => {
  try {
    const response = await fetch(env.APIPath.addDGmember, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(dgdata),
    });
    const data = await response.json();
    if (data.status === "ok") {
      // console.log(data)
      return data;
    } else {
      console.log(data);
    }
  } catch (error) {
    console.log(error.message);
  }
};

// const DeleteDGMember = async (token, dgdata) => {
//   try {
//     const response = await fetch(env.APIPath.deleteDGmember, {
//       method: "DELETE",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//       body: JSON.stringify(dgdata),
//     });
//     const data = await response.json();
//     if (data.status === "ok") {
//       // console.log(data)
//       return data;
//     } else {
//       console.log(data);
//     }
//   } catch (error) {
//     console.log(error.message);
//   }
// };

const MoveDGMember = async (token, body) => {
  try {
    const response = await fetch(env.APIPath.moveDGmember, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (data.status === "ok") {
      return data;
    } else {
      return data;
    }
  } catch (error) {
    console.log(error.message);
  }
};

const MoveSiteMember = async (token, sitedata) => {
  try {
    const response = await fetch(
      env.APIPath.moveSitemember,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(sitedata),
      }
    );
    const data = await response.json();
    if (data.status === "ok") {
      return data;
    } else {
      return data;
    }
  } catch (error) {
    console.log(error.message);
  }
};

const GenerateTechsupport = async (token, request) => {
  try {
    const response = await fetch(
      env.APIPath.minerTechsupport,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(request),
      }
    );
    const data = await response.json();
    if (data.status === "ok") {
      // console.log(data);
      return data;
    } else {
      console.log(data);
      return data;
    }
  } catch (error) {
    console.log(error.message);
  }
};

const GetTSJobStatus = async (token, request) => {
  try {
    const response = await fetch(
      env.APIPath.getTSJobStatus,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(request),
      }
    );
    const data = await response.json();
    if (data.status === "ok") {
      // console.log(data);
      return data;
    } else {
      console.log(data);
      return data;
    }
  } catch (error) {
    console.log(error.message);
  }
};

const GetCommandStatus = async (token, request) => {
  try {
    const response = await fetch(
      env.APIPath.getCommandStatus,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(request),
      }
    );
    const data = await response.json();
    if (data.status === "ok") {
      // console.log(data);
      return data;
    } else {
      console.log(data);
      return data;
    }
  } catch (error) {
    console.log(error.message);
  }
};

const AddCustomNames = async (token, minernames) => {
  try {
    const response = await fetch(
      env.APIPath.addCustomNames,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(minernames),
      }
    );
    const data = await response.json();
    if (data.status === "ok") {
      // console.log(data);
      return data;
    } else {
      return data;
    }
  } catch (error) {
    console.log(error.message);
  }
};

const PostManualTune = async (token, tunedata) => {
  try {
    const response = await fetch(
      env.APIPath.manualEfficiencyTune,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(tunedata),
      }
    );
    const data = await response.json();
    if (data.status === "ok") {
      // console.log(data)
      return data;
    } else {
      console.log(data);
      return data;
    }
  } catch (error) {
    console.log(error.message);
  }
};

const PostPowerCurtail = async (token, pcInfo, op) => {
  // console.log('PostPowerCurtail', pcInfo, op)
  try {
    const response = await fetch(env.APIPath[op], {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(pcInfo),
    });
    const data = await response.json();
    if (data.status === "ok") {
      // console.log(data)
      return data;
    } else {
      console.log(data);
      return data;
    }
  } catch (error) {
    console.log(error.message);
  }
};

const DeletePowerCurtail = async (token, pcInfo) => {
  // console.log('PostPowerCurtail', pcInfo)
  try {
    const response = await fetch(
      env.APIPath.powerCurtailSchedule,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(pcInfo),
      }
    );
    const data = await response.json();
    if (data.status === "ok") {
      // console.log(data)
      return data;
    } else {
      console.log(data);
      return data;
    }
  } catch (error) {
    console.log(error.message);
  }
};

const PostOnboard = async (token, onboardData) => {
  try {
    const response = await fetch(env.APIPath.onboard, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(onboardData),
    });
    const data = await response.json();
    if (data.status === "ok") {
      console.log(data);
      return data;
    } else {
      console.log(data);
      return data;
    }
  } catch (error) {
    console.log(error.message);
  }
};

const PostImportDevices = async (token, importData) => {
  try {
    const response = await fetch(
      env.APIPath.importDevices,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(importData),
      }
    );
    const data = await response.json();
    if (data.status === "ok") {
      console.log("PostImportDevices", data);
      return data;
    } else {
      console.log("PostImportDevices", data);
      return data;
    }
  } catch (error) {
    console.log("PostImportDevices", error.message);
  }
};

// --- Offboarding wizard (issue #556) ---------------------------------------
// These three back the CS offboard flow. Errors are returned rather than
// swallowed, because the caller has to distinguish "nothing matched" from
// "the request failed" before it offers a destructive button.

const GetOffboardOrgs = async (token) => {
  try {
    const response = await fetch(env.APIPath.offboardOrgs, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return await response.json();
  } catch (error) {
    return { status: "error", msg: error.message };
  }
};

const PostResolveMiners = async (token, body) => {
  try {
    const response = await fetch(env.APIPath.resolveMiners, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });
    return await response.json();
  } catch (error) {
    return { status: "error", msg: error.message };
  }
};

const PostOffboardMiners = async (token, body) => {
  try {
    const response = await fetch(env.APIPath.offboardMiners, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });
    return await response.json();
  } catch (error) {
    return { status: "error", msg: error.message };
  }
};

const PostDeregisterDevices = async (token, importData) => {
  try {
    const response = await fetch(
      env.APIPath.deregisterDevices,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(importData),
      }
    );
    const data = await response.json();
    if (data.status === "ok") {
      console.log("deregisterDevices", data);
      return data;
    } else {
      console.log("deregisterDevices", data);
      return data;
    }
  } catch (error) {
    console.log("deregisterDevices", error.message);
  }
};

const PostRemoveOrgTechsupport = async (token, info) => {
  try {
    const response = await fetch(
      env.APIPath.removeOrgTechsupport,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(info),
      }
    );
    const data = await response.json();
    if (data.status === "ok") {
      console.log("PostRemoveOrgTechsupport", data);
      return data;
    } else {
      console.log("PostRemoveOrgTechsupport", data);
      return data;
    }
  } catch (error) {
    console.log("PostRemoveOrgTechsupport", error.message);
  }
};

const PostRemoveDevices = async (token, importData) => {
  try {
    const response = await fetch(
      env.APIPath.removeDevices,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(importData),
      }
    );
    const data = await response.json();
    if (data.status === "ok") {
      console.log("PostRemoveDevices", data);
      return data;
    } else {
      console.log("PostRemoveDevices", data);
      return data;
    }
  } catch (error) {
    console.log("PostRemoveDevices", error.message);
  }
};

const PostFluxGPT = async (token, body) => {
  try {
    let url =
      "https://stagingfluxgpt.auradine.gold:443/askFluxGPT";
    const prepareCmd = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ body: JSON.stringify(body) }),
    };
    const response = await fetch(url, prepareCmd);
    const data = await response.json();
    if (data.status === "ok") {
      //console.log(data)
      return data;
    } else {
      console.log("received error from server");
      return data;
    }
  } catch (error) {
    console.log("Fetch from FluxGPT Failed", error.message);
  }
};

const PostAutoTune = async (token, tunedata) => {
  try {
    const response = await fetch(env.APIPath.autotune, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(tunedata),
    });
    const data = await response.json();
    if (data.status === "ok") {
      // console.log(data)
      return data;
    } else {
      console.log(data);
      return data;
    }
  } catch (error) {
    console.log(error.message);
  }
};

const PostDGisTgtHR = async (token, req) => {
  try {
    const response = await fetch(env.APIPath.dgisTgtHR, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(req),
    });
    const data = await response.json();
    if (data.status === "ok") {
      // console.log(data)
      return data;
    } else {
      console.log(data);
    }
  } catch (error) {
    console.log(error.message);
  }
};

const PostInvite = async (token, invite) => {
  try {
    const response = await fetch(env.APIPath.invite, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        invite: invite,
      }),
    });
    const data = await response.json();
    if (data.status === "ok") {
      //console.log(data);
    } else {
      console.log(data);
    }
    return data;
  } catch (error) {
    console.log(error.message);
  }
};

const PostDomains = async (token, domains) => {
  try {
    const response = await fetch(env.APIPath.domains, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        whitelist: domains,
      }),
    });
    const data = await response.json();
    if (data.status === "ok") {
      // console.log(data);
    } else {
      console.log(data);
    }
    return data;
  } catch (error) {
    console.log(error.message);
  }
};

const MakeAdminOtherUser = async (token, otheruser) => {
  try {
    const response = await fetch(env.APIPath.otheruser, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        otheruser: otheruser,
      }),
    });
    const data = await response.json();
    if (data.status === "ok") {
      // console.log(data);
      return data;
    } else {
      console.log(data);
    }
  } catch (error) {
    console.log(error.message);
  }
};

const DeleteOtherUser = async (token, otheruser) => {
  try {
    const response = await fetch(env.APIPath.otheruser, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        otheruser: otheruser,
      }),
    });
    const data = await response.json();
    if (data.status === "ok") {
      return data;
    } else {
      console.log(data);
    }
  } catch (error) {
    console.log(error.message);
  }
};

const GetPrivacy = async (token, callback) => {
  try {
    const response = await fetch(env.APIPath.privacy, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    // console.log(data);
    if (data.status === "ok") {
      if (callback) {
        callback(data.privacy);
      }
    } else {
      console.log(data);
    }
  } catch (error) {
    console.log(error.message);
  }
};

const PostPrivacy = async (token, privacy) => {
  try {
    const response = await fetch(env.APIPath.privacy, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        privacy: privacy,
      }),
    });
    const data = await response.json();
    // console.log(data);
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const SendCommands = async (token, info) => {
  try {
    console.log(env.APIPath.cloudcommand);
    const response = await fetch(env.APIPath.cloudcommand, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        SN: info.serials,
        CMD: info.commands,
        lastTs: info.lastTs,
      }),
    });
    const data = await response.json();
    // console.log(data);
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const SendGroupCommands = async (token, info) => {
  try {
    const response = await fetch(
      env.APIPath.groupcommands,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(info),
      }
    );
    const data = await response.json();
    // console.log(JSON.stringify(data));
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const SendSiteCommands = async (token, info) => {
  try {
    const response = await fetch(env.APIPath.sitecommands, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(info),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const SendAlertNotificationConfig = async (token, info) => {
  try {
    const response = await fetch(
      env.APIPath.alertNotificationConfig,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(info),
      }
    );
    const data = await response.json();
    // console.log(JSON.stringify(data));
    return data;
  } catch (error) {
    console.log(info, error.message);
  }
  return {
    status: "error",
  };
};

const CheckDatabase = async (token, info) => {
  try {
    const response = await fetch(
      env.APIPath.checkdatabase,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          SN: info.serials,
          CMD: info.commands,
          lastTs: info.lastTs,
        }),
      }
    );
    const data = await response.json();
    // console.log(data);
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const GetValidCommands = async (token) => {
  try {
    const response = await fetch(
      env.APIPath.validcommands,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    if (data.status === "ok") {
      return data.msg;
    } else {
      console.log(data);
    }
  } catch (error) {
    console.log(error.message);
  }
};

const GetAllDevices = async (token) => {
  try {
    const response = await fetch(env.APIPath.devicelist, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    if (data.status === "ok") {
      return data.devicelist;
    } else {
      console.log(data);
    }
  } catch (error) {
    console.log(error.message);
  }
};

const GetAllDeviceGroups = async (token) => {
  try {
    const response = await fetch(env.APIPath.dglist, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    if (data.status === "ok") {
      return data.devicegrouplist;
    } else {
      console.log(data);
    }
  } catch (error) {
    console.log(error.message);
  }
};

const IsOperationAllowed = async (token) => {
  try {
    const response = await fetch(
      env.APIPath.isOperationAllowed,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    if (data.status === "ok") {
      return data;
    } else {
      return data;
    }
  } catch (error) {
    console.log(error.message);
  }
};

const IsPoolOperationAllowed = async (token) => {
  try {
    const response = await fetch(
      env.APIPath.isPoolOperationAllowed,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    if (data.status === "ok") {
      return data;
    } else {
      return data;
    }
  } catch (error) {
    console.log(error.message);
  }
};

const GetDGInfo = async (token, info, op) => {
  try {
    const response = await fetch(env.APIPath[op], {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        dgname: info.dgName,
      }),
    });
    const data = await response.json();
    //console.log(data);
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};
const GetSiteInfo = async (token, info, op) => {
  try {
    const response = await fetch(env.APIPath[op], {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        siteName: info.siteName,
      }),
    });
    const data = await response.json();
    //console.log(data);
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const GetEnergyPrice = async (token, info) => {
  try {
    const response = await fetch(
      env.APIPath.getEnergyPrice,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          ISO: info.ISO,
          priceZone: info.priceZone,
        }),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const GetHashPrice = async (token) => {
  try {
    const response = await fetch(env.APIPath.getHashPrice, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const GetDGDevices = async (token, info) => {
  try {
    const response = await fetch(env.APIPath.dgdevices, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        dgname: info.dgName,
      }),
    });
    const data = await response.json();
    //console.log(data);
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const GetOrgDevices = async (token, info) => {
  try {
    const response = await fetch(env.APIPath.orgdevices, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        org_id: info.org_id,
      }),
    });
    const data = await response.json();
    //console.log(data);
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const GetDGView = async (token, info) => {
  try {
    const response = await fetch(env.APIPath.dgview, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    if (data.status === "ok") {
      return data.dgview;
    } else {
      console.log(data);
      return {
        status: "error",
      };
    }
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const GetSiteView = async (token, info) => {
  try {
    const response = await fetch(env.APIPath.siteview, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    if (data.status === "ok") {
      return data.siteview;
    } else {
      console.log(data);
      return {
        status: "error",
      };
    }
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const GetDGNames = async (token) => {
  try {
    const response = await fetch(env.APIPath.dgnames, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    if (data.status === "ok") {
      return data.devicegrouplist;
    } else {
      console.log(data);
      return {
        status: "error",
      };
    }
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};
const PostSiteView = async (token, info) => {
  try {
    const response = await fetch(env.APIPath.siteview, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      method: "POST",
      body: JSON.stringify({
        siteName: info.siteName,
      }),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const PostDGView = async (token, info) => {
  try {
    const response = await fetch(env.APIPath.dgview, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      method: "POST",
      body: JSON.stringify({
        siteName: info.siteName,
        dgname: info.dgname,
      }),
    });

    const data = await response.json();

    if (data.status === "ok") {
      return data;
    } else {
      console.log(data);
      return {
        status: "error",
      };
    }
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const PostDGConfig = async (token, info) => {
  try {
    const response = await fetch(env.APIPath.dgconfig, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        dgname: info.dgName,
        config: info.config,
      }),
    });
    const data = await response.json();
    // console.log(data);
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const PostMultiDGConfig = async (token, info) => {
  try {
    const response = await fetch(
      env.APIPath.multidgconfig,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          dglist: info.dglist,
          config: info.config,
        }),
      }
    );
    const data = await response.json();
    // console.log(data);
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const GetSiteNames = async (token) => {
  try {
    const response = await fetch(env.APIPath.sitenames, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const PostSiteConfig = async (token, info) => {
  try {
    const response = await fetch(env.APIPath.siteconfig, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        siteName: info.siteName,
        config: info.config,
      }),
    });
    const data = await response.json();
    // console.log(data);
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const PostMultiSiteConfig = async (token, info) => {
  try {
    const response = await fetch(
      env.APIPath.multisiteconfig,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          sitelist: info.sitelist,
          config: info.config,
        }),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const PostAutoTuneV2Config = async (
  token,
  configInfo,
  method
) => {
  try {
    // console.log("PostAutoTuneV2Config", method);
    if (method === "POST") {
      const response = await fetch(
        env.APIPath.autoTuneV2Config,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            config_type: configInfo.config_type,
            config_name: configInfo.config_name,
            config: configInfo.config,
            ...(configInfo.operation
              ? { operation: configInfo.operation }
              : {}),
          }),
        }
      );
      const data = await response.json();
      // console.log("PostAutoTuneV2Config Post", JSON.stringify(data));
      return data;
    } else if (method === "DELETE") {
      const response = await fetch(
        env.APIPath.autoTuneV2Config,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            config_type: configInfo.config_type,
            config_name: configInfo.config_name,
          }),
        }
      );
      const data = await response.json();
      // console.log("PostAutoTuneV2Config Delete", JSON.stringify(data));
      return data;
    } else if (method === "GET") {
      const response = await fetch(
        env.APIPath.getAutoTuneV2Config,
        {
          method: "POST", //BE it is a post method
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            config_type: configInfo.config_type,
            config_name: configInfo.config_name,
          }),
        }
      );
      const data = await response.json();
      // console.log("GetAutoTuneV2Config Get", JSON.stringify(data));
      return data;
    } else if (method === "GETALL") {
      const response = await fetch(
        env.APIPath.getAllAutoTuneV2Config,
        {
          method: "POST", //BE it is a post method
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            config_type: configInfo.config_type,
          }),
        }
      );
      const data = await response.json();
      // console.log("GetAllAutoTuneV2Config Get", JSON.stringify(data));
      return data;
    }
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const PostAttachAutoTuneV2Config = async (
  token,
  configInfo,
  sites,
  fvTuning
) => {
  console.log("sites in API", sites);
  try {
    const response = await fetch(
      env.APIPath.attachAutoTuneV2Config,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          sites: sites,
          fvTuning: fvTuning,
          config_type: configInfo.config_type,
          config_name: configInfo.config_name,
          attach: configInfo.attach,
        }),
      }
    );
    const data = await response.json();

    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const PostDesiredAlertIntervalCSTeam = async (
  token,
  info
) => {
  try {
    const response = await fetch(
      env.APIPath.desiredAlertIntervalCSTeam,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          desiredAlertInterval: info.desiredAlertInterval,
        }),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const FetchDashboardStatistics = async (
  queryKey,
  params
) => {
  try {
    const response = await fetch(env.APIPath.summary, {
      ...params,
      body: JSON.stringify(params.body),
    });
    if (!response.ok) {
      throw new Error(
        `HTTP error ! Status :${response.status}`
      );
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(
      "Error fetching data from API",
      error.message
    );
    throw error;
  }
};

const FetchDashboardStatisticsCS = async (
  queryKey,
  params
) => {
  try {
    const response = await fetch(env.APIPath.summaryCS, {
      ...params,
      body: JSON.stringify(params.body),
    });
    if (!response.ok) {
      throw new Error(
        `HTTP error ! Status :${response.status}`
      );
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(
      "Error fetching data from API",
      error.message
    );
    throw error;
  }
};

const FetchDashboardStatisticsLED = async (
  queryKey,
  params
) => {
  try {
    const response = await fetch(env.APIPath.summaryLED, {
      ...params,
      body: JSON.stringify(params.body),
    });
    if (!response.ok) {
      throw new Error(
        `HTTP error ! Status :${response.status}`
      );
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(
      "Error fetching data from API",
      error.message
    );
    throw error;
  }
};

const FetchDashboardStatisticsLEDCS = async (
  queryKey,
  params
) => {
  try {
    const response = await fetch(env.APIPath.summaryLEDCS, {
      ...params,
      body: JSON.stringify(params.body),
    });
    if (!response.ok) {
      throw new Error(
        `HTTP error ! Status :${response.status}`
      );
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(
      "Error fetching data from API",
      error.message
    );
    throw error;
  }
};

const GetCurrentTHsPowerForDashboard = async (
  queryKey,
  params
) => {
  try {
    const response = await fetch(env.APIPath.getCurrentTHsPowerForDashboard, {
      ...params,
      body: JSON.stringify(params.body),
    });
    if (!response.ok) {
      throw new Error(
        `HTTP error ! Status :${response.status}`
      );
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error.message);
  }
};

const GetIssuesCountForDashboard = async (
  queryKey,
  params
) => {
  try {
    const response = await fetch(env.APIPath.getIssuesCountForDashboard, {
      ...params,
      body: JSON.stringify(params.body),
    });
    if (!response.ok) {
      throw new Error(
        `HTTP error ! Status :${response.status}`
      );
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error.message);
  }
};

const GetIssuesCountForDashboardCS = async (
  queryKey,
  params
) => {
  try {
    const response = await fetch(env.APIPath.getIssuesCountForDashboardCS, {
      ...params,
      body: JSON.stringify(params.body),
    });
    if (!response.ok) {
      throw new Error(
        `HTTP error ! Status :${response.status}`
      );
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error.message);
  }
};

const GetSiteTemperatures = async (token) => {
  try {
    const response = await fetch(env.APIPath.siteTemperatures, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    if (data.status === "ok") {
      return data;
    } else {
      console.log(data);
    }
  } catch (error) {
    console.log(error.message);
  }
};

const GetAllDeviceGroupsUseQuery = async (
  queryKey,
  token
) => {
  try {
    const response = await fetch(env.APIPath.dglist, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    if (data.status === "ok") {
      return data.devicegrouplist;
    } else {
      console.log(data);
    }
  } catch (error) {
    console.log(error.message);
  }
};

const AddNewSite = async (siteData, token) => {
  const response = await fetch(env.APIPath.addSite, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      siteName: siteData.siteName,
      siteLocation: siteData.siteLocation
    }),
  });

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  return response.json();
};

const AddNewDGToSite = async (newSiteAndDg, token) => {
  const response = await fetch(env.APIPath.addDGToSite, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(newSiteAndDg),
  });

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  return response.json();
};
const DeleteSiteOrGroup = async (newSiteAndDg, token) => {
  const response = await fetch(
    env.APIPath.deleteSiteOrGroup,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newSiteAndDg),
    }
  );

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  return response.json();
};

const AddNewTag = async (body, token) => {
  const response = await fetch(env.APIPath.addTag, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  return response.json();
};

const DeleteTag = async (body, token) => {
  const response = await fetch(env.APIPath.deleteTag, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  return response.json();
};

const GetAllSitesList = async (token) => {
  try {
    const response = await fetch(env.APIPath.siteLists, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      // You could optionally throw an error here
      throw new Error("Network response was not ok");
    }
    const data = await response.json();
    return data; // Return user data
  } catch (error) {
    console.error("Error:", error.message);
    // Optionally, return some default value or throw the error
    throw error; // React Query will handle the error state
  }
};

const PostAllSitesList = async ({ token, body }) => {
  try {
    const response = await fetch(env.APIPath.siteLists, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (data.status === "ok") {
      return data;
    } else {
      throw new Error(data.msg || "Failed to fetch groups");
    }
  } catch (error) {
    console.error(
      "Error fetching data from API",
      error.message
    );
    throw error;
  }
};

const GetAllOrgsSitesList = async (token) => {
  try {
    const response = await fetch(env.APIPath.orgSiteLists, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      // You could optionally throw an error here
      throw new Error("Network response was not ok");
    }
    const data = await response.json();
    return data; // Return user data
  } catch (error) {
    console.error("Error:", error.message);
    // Optionally, return some default value or throw the error
    throw error; // React Query will handle the error state
  }
};

const PostUpdateSiteLocation = async (token, body) => {
  try {
    // console.log('in PostUser', user);
    const response = await fetch(env.APIPath.updateSiteLocation, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (data.status === "ok") {
      // console.log(data);
      return data;
    } else {
      console.log(data);
      throw new Error(data.msg || "Failed to update site location");
    }
  } catch (error) {
    console.log(error.message);
    throw error;
  }
};

const GetActiveCurtailmentSitesList = async (token) => {
  try {
    const response = await fetch(
      env.APIPath.activeCurtailmentSites,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      // You could optionally throw an error here
      throw new Error("Network response was not ok");
    }
    const data = await response.json();
    return data; // Return user data
  } catch (error) {
    console.error("Error:", error.message);
    // Optionally, return some default value or throw the error
    throw error; // React Query will handle the error state
  }
};

const PostAllTagsList = async ({ authToken, body }) => {
  try {
    const response = await fetch(env.APIPath.tagList, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (data.status === "ok") {
      return data;
    } else {
      throw new Error(data.msg || "Failed to fetch tags");
    }
  } catch (error) {
    console.error(
      "Error fetching data from API",
      error.message
    );
    throw error;
  }
};

const PostAllCBSNsList = async ({ authToken, body }) => {
  try {
    const response = await fetch(env.APIPath.listCBSNs, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (data.status === "ok") {
      return data;
    } else {
      throw new Error(data.msg || "Failed to fetch tags");
    }
  } catch (error) {
    console.error(
      "Error fetching data from API",
      error.message
    );
    throw error;
  }
};
const PostAllSerialNumbers = async ({
  authToken,
  body,
}) => {
  try {
    const response = await fetch(
      env.APIPath.listChassisSerialNumbers,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(body),
      }
    );
    const data = await response.json();
    if (data.status === "ok") {
      return data;
    } else {
      throw new Error(data.msg || "Failed to fetch tags");
    }
  } catch (error) {
    console.error(
      "Error fetching data from API",
      error.message
    );
    throw error;
  }
};

const PostAllMacs = async ({ authToken, body }) => {
  try {
    const response = await fetch(env.APIPath.listMacs, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (data.status === "ok") {
      return data;
    } else {
      throw new Error(data.msg || "Failed to fetch tags");
    }
  } catch (error) {
    console.error(
      "Error fetching data from API",
      error.message
    );
    throw error;
  }
};

const PostAllCaseNumbers = async ({ authToken, body }) => {
  try {
    const response = await fetch(env.APIPath.listCaseNumbers, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (data.status === "ok") {
      return data;
    } else {
      throw new Error(data.msg || "Failed to fetch case numbers");
    }
  } catch (error) {
    console.error(
      "Error fetching data from API",
      error.message
    );
    throw error;
  }
};

const PostAllCaseIssues = async ({ authToken, body }) => {
  try {
    const response = await fetch(env.APIPath.listCaseIssues, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (data.status === "ok") {
      return data;
    } else {
      throw new Error(data.msg || "Failed to fetch case issues");
    }
  } catch (error) {
    console.error(
      "Error fetching data from API",
      error.message
    );
    throw error;
  }
};

const PostAllGCMinerVersions = async ({
  authToken,
  body,
}) => {
  try {
    const response = await fetch(
      env.APIPath.listGCMinerVersions,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(body),
      }
    );
    const data = await response.json();
    if (data.status === "ok") {
      return data;
    } else {
      throw new Error(data.msg || "Failed to fetch tags");
    }
  } catch (error) {
    console.error(
      "Error fetching data from API",
      error.message
    );
    throw error;
  }
};

const PostAllTagsAttachedToMiners = async ({
  authToken,
  body,
}) => {
  try {
    const response = await fetch(
      env.APIPath.tagListFromMiners,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(body),
      }
    );
    const data = await response.json();
    if (data.status === "ok") {
      return data;
    } else {
      throw new Error(data.msg || "Failed to fetch tags");
    }
  } catch (error) {
    console.error(
      "Error fetching data from API",
      error.message
    );
    throw error;
  }
};

const AttachTagsToMiners = async (body, token) => {
  try {
    const response = await fetch(
      env.APIPath.attachTagsToMiners,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    return response.json();
  } catch (error) {
    console.error(
      "Error fetching data from API",
      error.message
    );
    throw error;
  }
};

const GetFilterListNames = async (token) => {
  try {
    const response = await fetch(
      env.APIPath.filterListNames,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();

    if (data.status === "ok") {
      return data;
    } else {
      throw new Error(
        data.message || "Failed to fetch filter list names"
      );
    }
  } catch (error) {
    console.error("Error:", error.message);
    throw error;
  }
};

const GetFilterList = async (body, token) => {
  try {
    const response = await fetch(
      env.APIPath.getFilterList,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();

    if (data.status === "ok") {
      return data;
    } else {
      throw new Error(
        data.message ||
          "Failed to fetch filter list content"
      );
    }
  } catch (error) {
    console.error("Error:", error.message);
    throw error;
  }
};

const PostSavedLists = async (body, token) => {
  try {
    const response = await fetch(
      env.APIPath.addFilterList,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    return response.json();
  } catch (error) {
    console.error(
      "Error fetching data from API",
      error.message
    );
    throw error;
  }
};

const DeleteSavedList = async (body, token) => {
  try {
    const response = await fetch(
      env.APIPath.deleteFilterList,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    return response.json();
  } catch (error) {
    console.error(
      "Error deleting data from API",
      error.message
    );
    throw error;
  }
};

// Case Filter Management API Functions
const GetCaseFilterListNames = async (token) => {
  try {
    const response = await fetch(
      env.APIPath.casefilterListNames,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();

    if (data.status === "ok") {
      return data;
    } else {
      throw new Error(
        data.message || "Failed to fetch case filter list names"
      );
    }
  } catch (error) {
    console.error("Error:", error.message);
    throw error;
  }
};

const GetCaseFilterList = async (body, token) => {
  try {
    const response = await fetch(
      env.APIPath.getCaseFilterList,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();

    if (data.status === "ok") {
      return data;
    } else {
      throw new Error(
        data.message ||
          "Failed to fetch case filter list content"
      );
    }
  } catch (error) {
    console.error("Error:", error.message);
    throw error;
  }
};

const PostCaseSavedLists = async (body, token) => {
  try {
    const response = await fetch(
      env.APIPath.addCaseFilterList,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    return response.json();
  } catch (error) {
    console.error(
      "Error fetching data from API",
      error.message
    );
    throw error;
  }
};

const DeleteCaseSavedList = async (body, token) => {
  try {
    const response = await fetch(
      env.APIPath.deleteCaseFilterList,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    return response.json();
  } catch (error) {
    console.error(
      "Error deleting data from API",
      error.message
    );
    throw error;
  }
};

const PostAllCaseCreatedBy = async ({ authToken, body }) => {
  try {
    const response = await fetch(
      env.APIPath.listCaseCreatedBy,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(body),
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();

    if (data.status === "ok") {
      return data;
    } else {
      throw new Error(
        data.message || "Failed to fetch case created by list"
      );
    }
  } catch (error) {
    console.error("Error:", error.message);
    throw error;
  }
};

const PostAllCaseSerialNo = async ({ authToken, body }) => {
  try {
    const response = await fetch(
      env.APIPath.listCaseSerialNo,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(body),
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();

    if (data.status === "ok") {
      return data;
    } else {
      throw new Error(
        data.message || "Failed to fetch case serial numbers list"
      );
    }
  } catch (error) {
    console.error("Error:", error.message);
    throw error;
  }
};

const PostAllCaseUpdatedBy = async ({ authToken, body }) => {
  try {
    const response = await fetch(
      env.APIPath.listCaseUpdatedBy,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(body),
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();

    if (data.status === "ok") {
      return data;
    } else {
      throw new Error(
        data.message || "Failed to fetch case updated by list"
      );
    }
  } catch (error) {
    console.error("Error:", error.message);
    throw error;
  }
};

const GetCaseCommentHistory = async ({ authToken, body }) => {
  try {
    console.log("GetCaseCommentHistory API call:", {
      url: env.APIPath.getCaseCommentHistory,
      authToken: authToken ? "present" : "missing",
      body: body
    });

    const response = await fetch(
      env.APIPath.getCaseCommentHistory,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(body),
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();

    if (data.status === "ok") {
      return data;
    } else {
      throw new Error(
        data.message || data.msg || "Failed to get case comment history"
      );
    }
  } catch (error) {
    console.error("Error:", error.message);
    throw error;
  }
};

const SendCaseCommands = async ({ authToken, body }) => {
  try {
    const response = await fetch(
      env.APIPath.caseCommands,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(body),
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();

    if (data.status === "ok") {
      return data;
    } else {
      throw new Error(
        data.message || data.msg || "Failed to execute case command"
      );
    }
  } catch (error) {
    console.error("Error:", error.message);
    throw error;
  }
};

const DetachTagsFromMiners = async (body, token) => {
  const response = await fetch(
    env.APIPath.detachTagsFromMiners,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    }
  );

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  return response.json();
};

const AddCSTags = async (body, token) => {
  const response = await fetch(env.APIPath.addCSTags, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  return response.json();
};

const postNewPreferences = async ({ authToken, body }) => {
  try {
    const response = await fetch(
      env.APIPath.preferenceNew,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(body),
      }
    );
    if (!response.ok) {
      throw new Error(
        `HTTP error ! Status :${response.status}`
      );
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(
      "Error fetching data from API",
      error.message
    );
    throw error;
  }
};

const postNewPreferencesCS = async ({
  authToken,
  body,
}) => {
  try {
    const response = await fetch(
      env.APIPath.preferenceNewCS,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(body),
      }
    );
    if (!response.ok) {
      throw new Error(
        `HTTP error ! Status :${response.status}`
      );
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(
      "Error fetching data from API",
      error.message
    );
    throw error;
  }
};

const postAPIKeyForUser = async ({ authToken, body }) => {
  try {
    const response = await fetch(env.APIPath.handleAPIKey, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(body),
    });
    if (!response.ok) {
      throw new Error(
        `HTTP error ! Status :${response.status}`
      );
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(
      "Error fetching data from API",
      error.message
    );
    throw error;
  }
};

const PostNewMinerDevice = async ({ authToken, body }) => {
  try {
    const response = await fetch(env.APIPath.deviceNew, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(body),
    });
    if (!response.ok) {
      throw new Error(
        `HTTP error! Status: ${response.status}`
      );
    }
    const data = await response.json();

    return data;
  } catch (error) {
    console.error(
      "Error fetching data from API",
      error.message
    );
    throw error;
  }
};

const PostNewMinerDeviceCS = async ({
  authToken,
  body,
}) => {
  try {
    const response = await fetch(env.APIPath.deviceNewCS, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(body),
    });
    if (!response.ok) {
      throw new Error(
        `HTTP error! Status: ${response.status}`
      );
    }
    const data = await response.json();

    return data;
  } catch (error) {
    console.error(
      "Error fetching data from API",
      error.message
    );
    throw error;
  }
};

const PostCaseList = async ({ authToken, body }) => {
  try {
    const response = await fetch(env.APIPath.caselist, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(body),
    });
    if (!response.ok) {
      throw new Error(
        `HTTP error! Status: ${response.status}`
      );
    }
    const data = await response.json();

    return data;
  } catch (error) {
    console.error(
      "Error fetching case list from API",
      error.message
    );
    throw error;
  }
};

const GetIssueSummaryBreakdown = async ({ authToken }) => {
  try {
    const response = await fetch(env.APIPath.getIssueSummaryBreakdown, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify({}), // Empty body since no filters needed
    });
    if (!response.ok) {
      throw new Error(
        `HTTP error! Status: ${response.status}`
      );
    }
    const data = await response.json();

    return data;
  } catch (error) {
    console.error(
      "Error fetching issue summary breakdown from API",
      error.message
    );
    throw error;
  }
};

const GetCaseStatusBreakdown = async ({ authToken, filters = {} }) => {
  try {
    // Convert filters object to array format expected by backend
    const filtersArray = Object.keys(filters).length > 0 ? [filters] : [];

    const response = await fetch(env.APIPath.getCaseStatusBreakdown, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify({ filters: filtersArray }), // Send filters as array
    });
    if (!response.ok) {
      throw new Error(
        `HTTP error! Status: ${response.status}`
      );
    }
    const data = await response.json();

    return data;
  } catch (error) {
    console.error(
      "Error fetching case status breakdown from API",
      error.message
    );
    throw error;
  }
};

const FetchHeatMapDataBySerialNumber = async ({
  authToken,
  serialNumber,
}) => {
  try {
    const response = await fetch(env.APIPath.chipStats, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify({ serialno: serialNumber }),
    });
    if (!response.ok) {
      throw new Error(
        `HTTP error! Status: ${response.status}`
      );
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(
      "Error fetching data from API ",
      error.message
    );
    throw error;
  }
};

const FetchHeatMapDataBySerialNumberCS = async ({
  authToken,
  serialNumber,
}) => {
  try {
    const response = await fetch(env.APIPath.chipStatsCS, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify({ serialno: serialNumber }),
    });
    if (!response.ok) {
      throw new Error(
        `HTTP error! Status: ${response.status}`
      );
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(
      "Error fetching data from API ",
      error.message
    );
    throw error;
  }
};

const PostExportCases = async (token, info) => {
  try {
    const response = await fetch(env.APIPath.exportCases, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(info),
    });

    const jsonResponse = await response.json();
    if (jsonResponse.status !== "ok") {
      console.error("Export failed:", jsonResponse.message);
      return {
        status: "error",
        msg: jsonResponse.msg,
      };
    }

    // Decode the base64 content
    const binaryString = atob(jsonResponse.docs);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    const decompressedDocs = pako.inflate(bytes, {
      to: "string",
    });

    // Step 3: Convert the decompressed data to a Blob for downloading
    const blob = new Blob([decompressedDocs], {
      type: "text/csv",
    });
    const url = window.URL.createObjectURL(blob);

    // Step 4: Create and trigger a download link
    const a = document.createElement("a");
    a.href = url;
    a.download = "CaseManagement.csv";
    document.body.appendChild(a);
    a.click();
    a.remove();
    // Clean up the blob URL
    window.URL.revokeObjectURL(url);

    return {
      status: "ok",
      msg: "Downloaded successfully",
    };
  } catch (error) {
    console.error("Download failed:", error.message);
    return {
      status: "error",
      msg: error.message,
    };
  }
};

const PostExport = async (token, info) => {
  try {
    const response = await fetch(env.APIPath.export, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(info),
    });

    const jsonResponse = await response.json();
    if (jsonResponse.status !== "ok") {
      console.error("Export failed:", jsonResponse.message);
      return {
        status: "error",
        msg: jsonResponse.msg,
      };
    }

    // Decode the base64 content
    const binaryString = atob(jsonResponse.docs);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    const decompressedDocs = pako.inflate(bytes, {
      to: "string",
    });

    // Step 3: Convert the decompressed data to a Blob for downloading
    const blob = new Blob([decompressedDocs], {
      type: "text/csv",
    });
    const url = window.URL.createObjectURL(blob);

    // Step 4: Create and trigger a download link
    const a = document.createElement("a");
    a.href = url;
    a.download = "MinerStats.csv";
    document.body.appendChild(a);
    a.click();
    a.remove();
    // Clean up the blob URL
    window.URL.revokeObjectURL(url);

    return {
      status: "ok",
      msg: "Downloaded successfully",
    };
  } catch (error) {
    console.error("Download failed:", error.message);
    return {
      status: "error",
      msg: error.message,
    };
  }
};

const PostAcceptedPools = async (token, body) => {
  try {
    const response = await fetch(
      env.APIPath.postacceptedpools,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      }
    );
    const data = await response.json();
    console.log("PostAcceptedPools ", JSON.stringify(data));
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const PostDeleteAcceptedPools = async (token, body) => {
  try {
    const response = await fetch(
      env.APIPath.postdeleteacceptedpools,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      }
    );
    const data = await response.json();
    console.log(
      "PostDeleteAcceptedPools ",
      JSON.stringify(data)
    );
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const AddAlertNotifications = async (token, data) => {
  try {
    const finalData = Object.values(data);
    const response = await fetch(
      env.APIPath.alertNotificationConfigAtUser,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(finalData),
      }
    );
    const jsonResponse = await response.json();
    return jsonResponse;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const SetAlertConfig = async (token, data) => {
  try {
    const response = await fetch(
      env.APIPath.setAlertConfig,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      }
    );
    const jsonResponse = await response.json();
    return jsonResponse;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const PostPermissions = async (token, data) => {
  try {
    const response = await fetch(
      env.APIPath.PostPermissions,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      }
    );
    const jsonResponse = await response.json();
    return jsonResponse;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};
const GetMaxLimits = async (token) => {
  try {
    const response = await fetch(env.APIPath.getmaxlimits, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error.message);
  }
};

const TransferMiners = async (token, info) => {
  try {
    const response = await fetch(env.APIPath.transfer, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(info),
    });
    const data = await response.json();
    console.log("TransferMiners", JSON.stringify(data));
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const AcceptTransferMiners = async (token, info) => {
  try {
    const response = await fetch(
      env.APIPath.acceptTransfer,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(info),
      }
    );
    const data = await response.json();
    console.log(
      "AcceptTransferMiners",
      JSON.stringify(data)
    );
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const RejectTransferMiners = async (token, info) => {
  try {
    const response = await fetch(
      env.APIPath.rejectTransfer,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(info),
      }
    );
    const data = await response.json();
    console.log(
      "RejectTransferMiners",
      JSON.stringify(data)
    );
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

const PostMinerRemoveOperation = async (token, info) => {
  try {
    const response = await fetch(
      env.APIPath.minerRemoveOperation,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(info),
      }
    );
    const data = await response.json();
    console.log(
      "PostMinerRemoveOperation",
      JSON.stringify(data)
    );
    return data;
  } catch (error) {
    console.log(error.message);
  }
  return {
    status: "error",
  };
};

export {
  PostDesiredAlertIntervalCSTeam,
  GetOrg,
  PostAutoTuneV2Config,
  PostAttachAutoTuneV2Config,
  PostOrg,
  PostOrgV2,
  PostOrgTechsupport,
  GetUser,
  GetAllSitesList,
  PostAllSitesList,
  GetAllOrgsSitesList,
  PostUpdateSiteLocation,
  GetActiveCurtailmentSitesList,
  AddNewSite,
  GetUserUseQuery,
  GetUserTechsupport,
  PostUserColorTheme,
  GetUserTechsupportFilter,
  GetJobs,
  PostJobsBySerial,
  PostJobsBySerialCS,
  PostJobDetailsByID,
  PostJobInfoByID,
  PostUser,
  PostUserSubscriptionPreference,
  PostUserPreference,
  PostUserWithAPIKeyNew,
  postNewPreferences,
  postNewPreferencesCS,
  PostAPIKey,
  //tag management
  PostAllTagsList,
  AddNewTag,
  DeleteTag,
  AttachTagsToMiners,
  PostAllTagsAttachedToMiners,
  DetachTagsFromMiners,
  AddCSTags,
  PostBTC,
  PostManualTune,
  postAPIKeyForUser,
  PostPowerCurtail,
  DeletePowerCurtail,
  PostOnboard,
  PostImportDevices,
  PostDeregisterDevices,
  GetOffboardOrgs,
  PostResolveMiners,
  PostOffboardMiners,
  PostRemoveOrgTechsupport,
  PostNewMinerDevice,
  PostNewMinerDeviceCS,
  PostRemoveDevices,
  PostAutoTune,
      PostExport,
    PostExportCases,
  PostDGisTgtHR,
  PostInvite,
  MakeAdminOtherUser,
  DeleteOtherUser,
  GetPrivacy,
  PostPrivacy,
  SendCommands,
  SendGroupCommands,
  SendSiteCommands,
  CheckDatabase,
  GetValidCommands,
  GetAllDevices,
  GetAllDeviceGroups,
  GetDGInfo,
  GetSiteInfo,
  GetDGDevices,
  GetEnergyPrice,
  GetHashPrice,
  GetOrgDevices,
  PostDGConfig,
  PostMultiDGConfig,
  GetSiteNames,
  PostSiteConfig,
  PostMultiSiteConfig,
  AddDGMember,
  PostAllCBSNsList,
  PostAllSerialNumbers,
  PostAllMacs,
  PostAllCaseNumbers,
  PostAllCaseIssues,
  PostAllCaseCreatedBy,
  PostAllCaseSerialNo,
  PostAllCaseUpdatedBy,
      SendCaseCommands,
    GetCaseCommentHistory,
  PostAllGCMinerVersions,
  //DeleteDGMember,
  MoveDGMember,
  MoveSiteMember,
  GenerateTechsupport,
  GetTSJobStatus,
  GetCommandStatus,
  AddDG,
  AddSite,
  AddNewDGToSite,
  DeleteSiteOrGroup,
  DeleteDG,
  DeleteSite,
  GetDGOrgConfig,
  GetDGOrgConfigV2,
  GetSiteOrgConfig,
  PostDGOrgConfig,
  PostDGOrgConfigV2,
  PostSiteOrgConfig,
  PostMultiDGOrgConfig,
  PostMultiDGOrgConfigV2,
  PostMultiSiteOrgConfig,
  PostFluxGPT,
  GetDGView,
  GetSiteView,
  GetDGNames,
  IsOperationAllowed,
  IsPoolOperationAllowed,
  AddCustomNames,
  SendAlertNotificationConfig,
  PostDomains,
  FetchDashboardStatistics,
  FetchDashboardStatisticsLED,
  FetchDashboardStatisticsLEDCS,
  GetCurrentTHsPowerForDashboard,
  GetIssuesCountForDashboard,
  GetIssuesCountForDashboardCS,
  GetSiteTemperatures,
  FetchHeatMapDataBySerialNumber,
  FetchHeatMapDataBySerialNumberCS,
  GetAllDeviceGroupsUseQuery,
  PostSiteView,
  PostDGView,
  PostAcceptedPools,
  PostDeleteAcceptedPools,
  AddAlertNotifications,
  GetOrgUseQuery,
  GetAlertSubscriptions,
  SetAlertConfig,
  PostPermissions,
  GetMaxLimits,
  TransferMiners,
  AcceptTransferMiners,
  RejectTransferMiners,
  PostMinerRemoveOperation,
  FetchDashboardStatisticsCS,
  PostJobDetailsByIDCount,
  GetFilterListNames,
  GetFilterList,
  PostSavedLists,
  DeleteSavedList,
  GetCaseFilterListNames,
  GetCaseFilterList,
  PostCaseSavedLists,
  DeleteCaseSavedList,
  PostCaseList,
  GetIssueSummaryBreakdown,
  GetCaseStatusBreakdown,
};
